import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';

import CheckLandsButton from '../../atoms/CheckLandsButton';
import Pattern from '../../../assets/pattern.png';
import MaximsLogo from '../../../assets/maxims-logo.png';
import MonopolyTitle from '../../../assets/monopoly-title.png';
import MonopolyLogo from '../../../assets/Monopoly_Logo_GB.png';

const TopSectionWrapper = styled.div`
  background-image: url(${Pattern});
  background-size: cover;

  ${space}
`;

const ImageSection = styled.div`
  display: flex;

  ${space}
`;

const MonopolyTitleWrapper = styled.img`
  width: 30%;
  height: 100%;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const MonopolyLogoWrapper = styled.img`
  width: 40%;
  margin-right: 8px;
  margin-top: 8px;
  align-self: start;
`;

const MaximsLogoWrapper = styled.img`
  width: 30%;
  align-self: start;
`;

const SmallHeader = () => {
  return (
    <TopSectionWrapper p={['32px 16px 16px 16px', '48px 32px 16px 32px', '96px 32px 16px 32px']}>
      <ImageSection mb={['48px', '96px', '128px']}>
        <MonopolyTitleWrapper src={MonopolyTitle} />
        <LogoWrapper>
          <MonopolyLogoWrapper src={MonopolyLogo} />
          <MaximsLogoWrapper src={MaximsLogo} />
        </LogoWrapper>
      </ImageSection>
      <CheckLandsButton>查看我的地卡</CheckLandsButton>
    </TopSectionWrapper>
  );
};

export default SmallHeader;
